import NotificationComponent from './NotificationComponent';
export * from './NotificationComponent';
export default NotificationComponent;
